/**
 * NPP desktop sticky gallery helper.
 * Keeps existing column layout; only expands .npp__hero min-height so
 * position:sticky on .npp__media-col can travel while the right column scrolls.
 * Disabled below 1024px.
 */
(function () {
  'use strict';

  var MQ = window.matchMedia('(min-width: 1024px)');
  var hero = null;
  var info = null;
  var media = null;
  var raf = 0;

  function findEls() {
    var root = document.querySelector('.npp');
    if (!root) return false;
    hero = root.querySelector('.npp__hero');
    info = root.querySelector('.npp__info-col');
    media = root.querySelector('.npp__media-col');
    return !!(hero && info && media);
  }

  function sync() {
    if (!hero || !info || !media) return;

    if (!MQ.matches) {
      hero.style.minHeight = '';
      return;
    }

    var needed = Math.max(media.offsetHeight || 0, info.offsetHeight || 0);
    if (needed > 0) {
      hero.style.minHeight = needed + 'px';
    }
  }

  function scheduleSync() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      raf = 0;
      sync();
    });
  }

  function init() {
    if (!findEls()) return;

    sync();

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(scheduleSync);
      ro.observe(info);
      ro.observe(media);
    }

    window.addEventListener('resize', scheduleSync, { passive: true });
    if (typeof MQ.addEventListener === 'function') {
      MQ.addEventListener('change', scheduleSync);
    } else if (typeof MQ.addListener === 'function') {
      MQ.addListener(scheduleSync);
    }

    // Images / apps can change right-column height after load
    window.addEventListener('load', scheduleSync);
    setTimeout(scheduleSync, 500);
    setTimeout(scheduleSync, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
